import { createActionCreator, paramsEncode } from '../../../utils';
import request from '../../../utils/request';
import constant from './constant';
import Urls from '../../../../config/index';
import moment from 'moment';

export const createLoadingAction = createActionCreator(constant.loading, loading => loading);
export const createStatisticsListAction = createActionCreator(constant.statisticList, list => list);
export const createPhoneConnListAction = createActionCreator(constant.phoneConnList, list => list);
export const createNolmalXDataAction = createActionCreator(constant.nolmalXdata, list => list);
export const createTencentXYDataAction = createActionCreator(constant.tencentXYdata, list => list);

export const createSearchAction = createActionCreator(constant.search, o => o);
export const createAgentsAction = createActionCreator(constant.agents, list => list);

let getNomalAgentConnInfoUrl = Urls.AgentConnectUrl.getNomalAgentConnInfo;
let getPhoneConnInfoUrl = Urls.AgentConnectUrl.getAgentConnInfo;

let partnerUrl = Urls.PartnerUrl;
// 获取合作商
export const getAgentsInfo = () => {
    return async (dispatch, getState) => {
        try {
            let response = await request(partnerUrl.paramList);
            dispatch(createAgentsAction(response.partnerName));
           // dispatch(createAreasAction(response.area));
        } catch (e) {
            throw new Error(e);
        }
    }
}


//获取nolmal模块的列表和两个曲线的数据
export const getNolmalList = () => {
    return async (dispatch, getState) => {
        try {
            let search = getState().agentConnentData.search;
            let response ;
            if(search==undefined || Object.keys(search).length==0){
                const today = moment().format('YYYY-MM-DD')
                search = "day="+today;
                response = await request(getNomalAgentConnInfoUrl + search);
                dispatch(createStatisticsListAction(response.connectNumList));
            }else{   
                response = await request(getNomalAgentConnInfoUrl + paramsEncode(Object.assign(search)));
                dispatch(createStatisticsListAction(response.connectNumList));
            }
            //获取常规连接数曲线数据
            dispatch(createNolmalXDataAction(response.nolmalXYnum));
            //获取腾讯云外网入带宽曲线数据
            dispatch(createTencentXYDataAction(response.monitorNum));
        
        } catch (e) {
            throw new Error(e);
        }
    }
}

export const getPhoneConnList = () => {
    return async (dispatch, getState) => {
        try {
            let search = getState().agentConnentData.search;
            if(search==undefined || Object.keys(search).length==0){
                const today = moment().format('YYYY-MM-DD')
                search = "day="+today;
                let response = await request(getPhoneConnInfoUrl + search);
                dispatch(createPhoneConnListAction(response));
            }else{
                let response = await request(getPhoneConnInfoUrl + paramsEncode(Object.assign(search)));
                dispatch(createPhoneConnListAction(response));
            }
        } catch (e) {
            throw new Error(e);
        }
    }
}

//
export const onFieldsChange = (search) => {
    return (dispatch, getState) => {
        dispatch(createSearchAction(search));
    }
}



// WEBPACK FOOTER //
// ./pages/StatisticalAnalysis/agentConnentData/action.js